export default __webpack_public_path__ + "static/media/2745.d02b4e07.svg";